import React from "react";
import PropTypes from "prop-types";

import IconGitHub from "./github";
import IconLinkedin from "./linkedin";
import IconTwitter from "./twitter";
import IconLogo from "./logo";

const Icon = ({ name }) => {
  switch (name) {
    case "GitHub":
      return <IconGitHub />;
    case "Linkedin":
      return <IconLinkedin />;
    case "Logo":
      return <IconLogo />;
    case "Twitter":
      return <IconTwitter />;
    default:
      return <IconLogo />;
  }
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Icon;